import {
  DEFAULT_COMPANY,
  DEFAULT_BBEE,
  DEFAULT_VERIFICATION_AGENCY,
  DEFAULT_VERIFICATION_DOCUMENTS,
  DEFAULT_CONSULTANT,
  DEFAULT_CONSULTANT_DOCUMENTS,
  DEFAULT_BEE_MANAGER,
  DEFAULT_BEE_ELEMENT_OWNERS,
} from '../../../data/company_profile_data.js';

export default {
  name: "quick_actions",

  data() {
    return ({
      active_tab: "overview",

      // UI state
      is_loading: false,
      error_message: null,

      // defaults (use copies to avoid shared mutation)
      company: { ...DEFAULT_COMPANY },
      bbbee: { ...DEFAULT_BBEE },
      verification_agency: { ...DEFAULT_VERIFICATION_AGENCY },
      verification_documents: [...DEFAULT_VERIFICATION_DOCUMENTS],
      consultant: { ...DEFAULT_CONSULTANT },
      consultant_documents: [...DEFAULT_CONSULTANT_DOCUMENTS],
      bee_manager: { ...DEFAULT_BEE_MANAGER },
      bee_element_owners: [...DEFAULT_BEE_ELEMENT_OWNERS],
    });
  },

  mounted() {
    this.load_local_company_profile();
  },

  methods: {
    set_active_tab(tab_key) {
      this.active_tab = tab_key;
      sessionStorage.setItem("company_profile_active_tab", tab_key);
    },

    load_local_company_profile() {
      this.restore_active_tab();

      const parsed_profile = this.get_saved_company_profile();
      if (!parsed_profile) return;

      this.apply_company_profile(parsed_profile);
    },

    restore_active_tab() {
      const saved_tab = sessionStorage.getItem("company_profile_active_tab");
      if (saved_tab) {
        this.active_tab = saved_tab;
      }
    },

    get_saved_company_profile() {
      const saved_profile = sessionStorage.getItem("company_profile");
      if (!saved_profile) return null;

      try {
        return JSON.parse(saved_profile);
      } catch (error) {
        this.error_message = "Saved company profile data is invalid.";
        return null;
      }
    },

    merge_object_field(field_name, source) {
      if (source && source[String(field_name)] !== undefined) {
        this[String(field_name)] = { ...this[String(field_name)], ...source[String(field_name)] };
      }
    },

    merge_array_field(field_name, source) {
      if (source && source[String(field_name)] !== undefined && Array.isArray(source[String(field_name)])) {
        this[String(field_name)] = source[String(field_name)];
      }
    },

    apply_company_profile(parsed) {
      if (!parsed) return;

      // Apply object fields
      this.merge_object_field('company', parsed);
      this.merge_object_field('bbbee', parsed);
      this.merge_object_field('verification_agency', parsed);
      this.merge_object_field('consultant', parsed);
      this.merge_object_field('bee_manager', parsed);

      // Apply array fields
      this.merge_array_field('verification_documents', parsed);
      this.merge_array_field('consultant_documents', parsed);
      this.merge_array_field('bee_element_owners', parsed);
    },
  }
};